import { render, staticRenderFns } from "./gisSyncMqList.vue?vue&type=template&id=15fc4ad2&scoped=true&"
import script from "./gisSyncMqList.vue?vue&type=script&lang=js&"
export * from "./gisSyncMqList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fc4ad2",
  null
  
)

export default component.exports